axios.defaults.timeout = 60000;
axios.defaults.headers = {
  "Cache-Control": "no-cache, no-store",
  "Pragma": "no-cache",
  "Expires": "0",
}

export const apiPerfix = () => 'api/v1';

export const api = options => {
  const headers = {}
  const isBundle = options?.data?.isBundle || false
  const isLitePath = window.location.pathname.startsWith("/lite/");
  if (isLitePath || isBundle) {
    Object.assign(headers, { "Aib-Lite": "1" });
  }
  return axios({
    ...options,
    headers,
    url: `/api/v1/${options.url}`,
  }).then((res) => {
    // console.debug(options.url, res?.headers?.['x-request-id'])
    return res
  })
}

export const apiRequest = (options) => {
  const instance = axios.create({
    timeout: 3000,
    async: true,
    crossDomain: true,
  });
  return instance({
    ...options,
    url: options.url
  });
};

export function createFormData(params) {
  const formData = new FormData()
  for (const [k, v] of Object.entries(params)) {
    formData.append(k, v)
  }
  return formData
}
